import * as amplitude from '@amplitude/analytics-browser';

const AMPLITUDE_KEY = process.env.REACT_APP_AMPLITUDE_SECRET;

export const initializeAmplitude = () => {
  amplitude.init(AMPLITUDE_KEY, {
    autocapture: { pageViews: true },
  });
};
export const trackPageChange = (pageName) => {
  amplitude.logEvent('pageview', { route: pageName });
};
export const logEvent = (eventName, eventSource) => {
  amplitude.logEvent(eventName, eventSource);
};
